import { modalConstants } from '../constants';

export function modal(state = {}, action) {
  switch (action.type) {
    case modalConstants.REDIRECT:
      return {
        redirect: action.data,
      };
    case modalConstants.LOGIN:
      return {
        ...state,
        login: {
          ...action.data,
        },
      };
    case modalConstants.USER_PROFILE_ONBOARDING:
      return {
        ...state,
        userProfileOnboarding: action.data,
      };
    case modalConstants.USER_LOCATION_ONBOARDING:
      return {
        ...state,
        userLocationOnboarding: action.data,
      };
    case modalConstants.NPS:
      return {
        ...state,
        nps: action.data,
      };
    case modalConstants.LAST_MINUTE:
      return {
        ...state,
        lastMinute: action.data,
      };

    case modalConstants.REVIEWS: {
      return {
        ...state,
        reviews: { ...state.reviews, ...action.payload },
      };
    }
    case modalConstants.ADD_REVIEWS_PREV_STATE: {
      return {
        ...state,
        reviews: { ...state.reviews, prevState: [...(state.reviews?.prevState || []), { ...action.payload }] },
      };
    }

    case modalConstants.REMOVE_REVIEWS_PREV_STATE: {
      const { id } = action.payload;
      return {
        ...state,
        reviews: {
          ...state.reviews,
          prevState: (state.reviews?.prevState || []).filter((item) => item.id !== id),
        },
      };
    }
    case modalConstants.RESET_REVIEWS_PREV_STATE: {
      return {
        ...state,
        reviews: {
          ...state.reviews,
          prevState: [],
        },
      };
    }

    case modalConstants.HIDE:
      return {};
    default:
      return state;
  }
}
